import {
  CheckboxProps as HeadlessCheckboxProps,
  Checkbox as HeadlessCheckbox,
  Field,
  Label,
} from "@headlessui/react";
import React, { RefObject, FC, ReactNode } from "react";

const BaseCheckbox: FC<HeadlessCheckboxProps> = (props) => (
  <HeadlessCheckbox
    className="border-swdc-gray-400 bg-swdc-white data-active:border-swdc-blue-300 data-checked:border-swdc-blue-500 data-disabled:border-swdc-gray-200 data-disabled:data-checked:bg-swdc-gray-200 group-hover:border-swdc-blue-300 data-checked:bg-swdc-blue-500 block flex aspect-square size-4 items-center justify-center border border-solid group-hover:cursor-pointer data-active:border-2 data-disabled:cursor-not-allowed data-disabled:border data-checked:data-disabled:opacity-75"
    data-automation-group="checkbox"
    {...props}
  >
    {({ checked, indeterminate }) =>
      checked && !indeterminate ? (
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
          aria-hidden
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 5.0959L4.33333 9L9 1"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : indeterminate ? (
        <svg
          width="12"
          height="2"
          viewBox="0 0 12 2"
          fill="none"
          aria-hidden
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1H11"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <></>
      )
    }
  </HeadlessCheckbox>
);

export type CheckboxInputProps = HeadlessCheckboxProps & {
  type: "checkbox";
  ref?: RefObject<HTMLElement | null>;
} & {
  variant: "form" | "filter" | "without-label";
  label?: string | ReactNode;
};
/**
 * DO NOT USE!
 * USE THE FACADE COMPONENT `Input` INSTEAD.
 */
export const CheckboxInput: FC<CheckboxInputProps> = ({ label, ...props }) => {
  switch (props.variant) {
    case "form":
      return (
        <Field className="group flex w-fit gap-x-4" disabled={props.disabled}>
          <BaseCheckbox {...props} />
          <Label className="group-hover:not-group-disabled:cursor-pointer group-disabled:cursor-not-allowed">
            {label}
          </Label>
        </Field>
      );
    case "filter":
      return (
        <Field
          disabled={props.disabled}
          className="group text-link-xs hover:bg-swdc-white flex flex-row items-center gap-x-1.5 px-1 py-0.5"
          data-automation-group="filter-item"
        >
          <BaseCheckbox {...props} />
          <Label className="text-swdc-gray-400 group-active:text-swdc-blue-500 group-active:decoration-swdc-blue-500 w-full group-hover:underline group-hover:not-group-disabled:cursor-pointer group-disabled:cursor-not-allowed">
            {label}
          </Label>
        </Field>
      );
    case "without-label":
    default:
      return <BaseCheckbox {...props} />;
  }
};
